module.exports = __webpack_public_path__ + "static/media/5p.20a9e855.jpg";